module.exports = __webpack_public_path__ + "static/media/long.4df3ed18.jpg";